const DEFAULT_RANDOM_CHARS = 'abcdefghijklmkopqrstuvwxyz0123456789';
const defaultRNG = (a)=>{
    if (window?.crypto !== null && window?.crypto !== undefined) {
        window.crypto.getRandomValues(a);
    } else {
        // Non-crypto RNG
        for(let i = 0; i < a.length; i++){
            a[i] = Math.random() % 255;
        }
    }
};
/**
 * A deterministic random number generator, suitable for use in tests
 *
 * @param a The array to populate with random values
 */ const fakeRNG = (a)=>{
    for(let i = 0; i < a.length; i++){
        a[i] = 255 - i % 255;
    }
};
let rng = defaultRNG;
/**
 * Sets the random number generator to the default RNG
 */ function usingDefaultRNG() {
    rng = defaultRNG;
}
/**
 * Sets the random number generator that should be used. Allows tests to override the default random
 * number generator.
 *
 * @param override The RNG to use.
 */ function usingRNG(override) {
    rng = override;
}
/**
 * Generate a random string of the given len from the provided set of characters. Uses
 * the crypto PRG so is suitable for auth-related values such as nonces.
 */ function randomString(len = 32, charset = DEFAULT_RANDOM_CHARS) {
    const randomBytes = new Uint8Array(len);
    rng(randomBytes);
    const randomChars = randomBytes.map((n)=>charset.charCodeAt(Math.abs(n) % charset.length));
    return String.fromCharCode(...Array.from(randomChars));
}

export { fakeRNG, randomString, usingDefaultRNG, usingRNG };
//# sourceMappingURL=random.js.map
